export const FILTER_TYPE_TO_ID_PREFIX: { [key: string]: string } = {
  ARRIVAL_AIRPORT: 'arrival-airport',
  ARRIVAL_TIME: 'arrival-time',
  DEPARTURE_AIRPORT: 'departure-airport',
  DEPARTURE_TIME: 'departure-time',
  DURATION: 'duration',
  NUM_OF_STOPS: 'stops',
  PREFERRED_AIRLINE: 'preferred-airline'
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const FILTER_TYPE_TO_VALUE: { [key: string]: (filterValue: any) => any } = {
  FlightsTimeBasedFilterValue: filterValue => filterValue.timeOfDay,
  FlightsAirportCodeFilterValue: filterValue => filterValue.airportCode,
  FlightsDurationBasedFilterValue: filterValue => filterValue.maxDuration,
  FlightsStopBasedFilterValue: filterValue => filterValue.stopInfo.numberOfStops,
  FlightsStopInfo: filterValue => filterValue.stopInfo.numberOfStops,
  FlightsPreferredAirlineFilterValue: filterValue => filterValue.carrierCode,
  FlightsFlexibleChangePolicyBasedFilterValue: filterValue => filterValue.policyName
};

export const FILTER_HEIGHT_IN_PX = 35;
export const FILTER_FADE_THRESHOLD_FACTOR = 0.6;
